import { useState, useCallback } from 'react';

import { SmartCaptcha } from '@yandex/smart-captcha';

interface Props {
  onTokenChange?: (token: string) => void;
}

const Captcha = ({ onTokenChange }: Props) => {
  const [token, setToken] = useState('');
  const [status, setStatus] = useState('hidden');

  const sitekey = process.env.REACT_APP_YANDEX_CAPTCHA_KEY;

  const handleSuccess = useCallback(
    (newToken: string) => {
      setStatus('success');
      setToken(newToken);
      onTokenChange?.(newToken);
    },
    [onTokenChange]
  );

  const handleTokenExpired = useCallback(() => {
    setStatus('token-expired');
    setToken('');
  }, []);

  const handleChallengeVisible = useCallback(() => setStatus('visible'), []);
  const handleChallengeHidden = useCallback(() => setStatus('hidden'), []);
  const handleNetworkError = useCallback(() => setStatus('network-error'), []);
  const handleJavascriptError = useCallback((error: any) => {
    setStatus('javascript-error');
    console.error(error);
  }, []);

  if (!sitekey) {
    return null;
  }

  return (
    <>
      <SmartCaptcha
        sitekey={sitekey}
        onSuccess={handleSuccess}
        onTokenExpired={handleTokenExpired}
        onChallengeVisible={handleChallengeVisible}
        onChallengeHidden={handleChallengeHidden}
        onNetworkError={handleNetworkError}
        onJavascriptError={handleJavascriptError}
      />
    </>
  );
};

export default Captcha;
